export const domain = {
  name: "https://www.dhl.com",
};
